/**
 * @generated SignedSource<<52d367ffbcd0d1a0943bf0aa5008c244>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EcommerceCustomizationStrategy = "CUSTOMIZER_BUNDLE" | "DUPLICATION" | "NO_DUPLICATION" | "OPTIMISTIC_DUPLICATION" | "SHOPIFY_CART_TRANSFORM" | "SHOPIFY_CART_TRANSFORM_PLUS";
export type productSidePanelContent_ShopifyCustomizationStrategyQuery$variables = Record<PropertyKey, never>;
export type productSidePanelContent_ShopifyCustomizationStrategyQuery$data = {
  readonly ecommerceSettingsAdditionalDataForEcommercePlatform: ReadonlyArray<{
    readonly customizationStrategy: EcommerceCustomizationStrategy;
  }>;
};
export type productSidePanelContent_ShopifyCustomizationStrategyQuery = {
  response: productSidePanelContent_ShopifyCustomizationStrategyQuery$data;
  variables: productSidePanelContent_ShopifyCustomizationStrategyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "ecommerce",
    "value": "SHOPIFY"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customizationStrategy",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_ShopifyCustomizationStrategyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "EcommerceSettingsAdditionalData",
        "kind": "LinkedField",
        "name": "ecommerceSettingsAdditionalDataForEcommercePlatform",
        "plural": true,
        "selections": [
          (v1/*:: as any*/)
        ],
        "storageKey": "ecommerceSettingsAdditionalDataForEcommercePlatform(ecommerce:\"SHOPIFY\")"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "productSidePanelContent_ShopifyCustomizationStrategyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "EcommerceSettingsAdditionalData",
        "kind": "LinkedField",
        "name": "ecommerceSettingsAdditionalDataForEcommercePlatform",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": "ecommerceSettingsAdditionalDataForEcommercePlatform(ecommerce:\"SHOPIFY\")"
      }
    ]
  },
  "params": {
    "cacheID": "821c292c899fac3b3b1e87decc164cef",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_ShopifyCustomizationStrategyQuery",
    "operationKind": "query",
    "text": "query productSidePanelContent_ShopifyCustomizationStrategyQuery {\n  ecommerceSettingsAdditionalDataForEcommercePlatform(ecommerce: SHOPIFY) {\n    customizationStrategy\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "69a0e40a024d4fb0e976b724355d19d6";

export default node;
